<div class="twc-select" [ngClass]="{'twc-select-opened': toggleSelect}">
    <div class="twc-select-content">
        <button class="twc-select-trigger" type="button" (click)="onToggleSelect()">
            <div class="twc-select-value-wrapper">
                <div class="twc-select-selected-option-container" *ngIf="option">
                    <div class="twc-select-selected-option-label">{{option.value}}</div>
                </div>
                <div *ngIf="!option && placeholder" class="twc-select-placeholder">{{placeholder}}</div>
                <twc-icon class="twc-select-icon" [ngClass]="{'icon-open': toggleSelect}" [size]="24"
                    [shape]="'acc-down'"></twc-icon>
            </div>
            <div class="twc-select-trigger-border-bottom"></div>
        </button>
        <div class="twc-select-menu" *ngIf="toggleSelect">
            <div class="twc-select-input-wrapper">
                <twc-icon class="twc-select-icon-search" [shape]="'search'"></twc-icon>
                <input type="text" [placeholder]="searchPlaceholder" [formControl]="searchText" (keyup)="filterOptions()">
                </div>
            <div class="twc-select-options-container-wrapper">
                <div role="listbox">
                    <twc-list-item *ngFor="let option of optionList" (click)="updateSelectedOption(option)">
                        <div class="twc-body twc-list-item-col-1">{{option.value}}</div>
                    </twc-list-item>
                </div>
                <div *ngIf="!optionList?.length && searchText.value.length >= minValueLength" class="twc-select-option-label">
                    <twc-icon shape="close"></twc-icon>
                    {{'GENERAL.NOT_RESULTS_FOUND' | translate}}
                </div>
            </div>
            </div>
            </div>
            </div>

<small class="twc-form-helper" *ngIf="selectedOptionInfo?.length">{{selectedOptionInfo}}</small>